import "../style/style.scss";
import makeCarousel from "./panels/carousel";
import { addObservatoriesToSelector } from "./observatories/init_observatories";
import { initializePage } from "./initialize";
import { parseURLToConfig } from "./urls";

// Setting up Carousel

parseURLToConfig();

makeCarousel();

addObservatoriesToSelector();

initializePage();
